// Angular
import { Injectable } from '@angular/core';

// Rxjs
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

// Ngrx
import { Action, Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';

// Actions
import { AppState } from '..';
import * as cartActions from '../cart/cart.actions';

// Services
import { WebtrekkService } from '../../shared/services/b2b/webtrekk.service';

@Injectable()
export class WebtrekkEffects {
    store: AppState = null;

    constructor(private actions$: Actions, private store$: Store<AppState>, private webtrekk: WebtrekkService) {
        this.store$
            .select((state) => state)
            .subscribe((store) => {
                this.store = store;
            });
    }

    updateCart$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(cartActions.CartActionTypes.DO_PUSH),
            switchMap((action: cartActions.DoPush) => {
                this.webtrekk.registerAddCartProduct(action.payload);
                return of({ type: 'WEBTREKK_ACTION' });
            })
        )
    );
}
